import { useEffect } from "react";
import "./ThankYouPage.scss";

const kotamLogo = "/assets/images/kotam-white-logo.png";
const kickstarterUrl = "https://www.kickstarter.com/projects/wherevergames/kotam-conquest?ref=2gn9ez";

export default function ThankYouPage() {
  const useHandleCheckout = async (e) => {
    e.preventDefault();
    
    const userEmail = "";
      const data = { email: userEmail };
      const response = await checkout(data);
      window.location.assign(response);
  };

  const createEventId = (prefix = "kotam") => {
    if (window.crypto && typeof window.crypto.randomUUID === "function") {
      return `${prefix}_${window.crypto.randomUUID()}`;
    }

    return `${prefix}_${Date.now()}_${Math.random().toString(36).slice(2, 12)}`;
  }

  const checkout = async (data) => {
    const endpoint = "https://kotamconquest.com/api/create_checkout_session.php";
    const formData = new FormData();
    formData.append('email', data['email']);

    var resp = "/thank-you";
    try {
      const eventId = createEventId(); //crypto.randomUUID();

      window.fbq('track', 'InitiateCheckout', {}, { eventID: eventId });
      formData.append("eventId", eventId);
      const response = await fetch(endpoint, {
        method: 'POST',
        body: formData,
      });

      const data = await response.json();
      if (data.url) {
        return data.url;
      }
    }
    catch(error) {
      console.error('Error:', error);
    }
    return resp;
  };

  useEffect(() => {
    const signupComplete = sessionStorage.getItem("kotam_signup_complete");

    if (signupComplete !== "true") {
      window.location.replace("/#signup");
    }
  }, []);

  return (
    <main className="thank-you">
      <nav className={`thank-you__navbar`}>
      <a href="#top" className="navbar__brand" aria-label="Kotam: Conquest home">
        <img
          src={kotamLogo}
          alt="Kotam: Conquest"
          className="navbar__logo"
        />
      </a>
      </nav>
      <section className="thank-you__hero">
        <div className="thank-you__glow thank-you__glow--gold" />
        <div className="thank-you__glow thank-you__glow--green" />

        <div className="thank-you__card">
          {/* <a className="thank-you__brand" href="/" aria-label="Back to Kotam: Conquest landing page">
            Kotam: Conquest
          </a> */}

          <span className="section-eyebrow">You are on the early access list</span>

          <h1>Thank You for Joining the Realm</h1>

          <p className="thank-you__intro">
            You will receive Kickstarter launch updates, first-look previews,
            and important launch-day details for Kotam: Conquest.
          </p>

          <div className="thank-you__reservation">
            <div className="thank-you__reservation-layout">
              
              <div className="thank-you__barrack-preview">
                
                <img
                  src="/assets/images/3d-barrack.webp"
                  alt="3D Barrack promo preview"
                  onError={(event) => {
                    event.currentTarget.style.display = "none";
                  }}
                />
              </div>
              {/* <div className="thank-you__barrack__badge">RESERVE ME</div> */}
              <div className="thank-you__reservation-copy">
                <span className="thank-you__label">Optional next step</span>
                <h2>Unlock the 3D Barrack Promo</h2>
                <p>
                  Reserve for $1 to secure access to the 3D Barrack promo when
                  Kotam: Conquest launches on Kickstarter.
                </p>
              </div>
            </div>
            <button
              className="btn btn-primary"
              type="button"
              onClick={useHandleCheckout}
            >
              Reserve for $1
            </button>
            <small>
              The $1 reservation is optional and fully refundable before
              Kickstarter launch.
            </small>
          </div>

          <div className="thank-you__secondary">
            <div>
              <h3>Follow the Kickstarter campaign</h3>
              <p>
                Follow Kotam: Conquest on Kickstarter so you are notified when
                the campaign goes live.
              </p>
            </div>

            <a
              className="btn thank-you__kickstarter"
              href={kickstarterUrl}
              target="_blank"
              rel="noreferrer"
            >
              Follow on Kickstarter
            </a>
          </div>

          <a className="thank-you__back" href="/">
            Back to landing page
          </a>
        </div>
      </section>
    </main>
  );
}
